export const languages = {
  english: "en",
  german: "de",
  french: 'fr',
}

export const localeBase = {
  languages: [languages.english, languages.german, languages.french],
  defaultLanguage: languages.english,
}
